var React = require('react');

function LogoNowatch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.8 18.1a7.7 7.7 0 01-7.8-7.6c0-4.2 3.5-7.7 7.8-7.7s7.8 3.5 7.8 7.7-3.5 7.6-7.8 7.6zm0-18.1C26.8 0 22 4.7 22 10.5S27 21 32.8 21c5.9 0 10.7-4.7 10.7-10.5S38.7 0 32.8 0zM14.9 20.7L2.9 4v16.7H0V.5h3.8L15 16V.5h2.8v20.2h-3zM70.2.5h3l-5.9 20.2h-2.9L59.1 4.3 54 20.7h-2.8L45.2.5h3l4.4 15.9 5-15.9h3l5.2 16 4.4-16zM79.5 12.5h7l-3.5-9-3.5 9zm8 2.6h-9l-2.1 5.6h-3l8-20.2h3.2l8.1 20.2h-3l-2.2-5.6zM102.5 3.1v17.6h-2.8V3.1H92V.5h18.3v2.6h-7.8zM150.2 20.7v-9h-11.5v9H136V.5h2.8v8.7h11.5V.5h2.8v20.2h-2.8zM129.4 13a7.7 7.7 0 01-15-2.5 7.7 7.7 0 0115-2.6h3c-1.2-4.5-5.3-7.9-10.3-7.9-5.8 0-10.6 4.7-10.6 10.5S116.3 21 122.1 21c5 0 9.1-3.4 10.3-8h-3z","fill":"currentColor"}));
}

LogoNowatch.defaultProps = {"viewBox":"0 0 153 21","fill":"none"};

module.exports = LogoNowatch;

LogoNowatch.default = LogoNowatch;
